import { useContext } from 'react';
import { isNullOrUndefined } from '@vy/utils';
import { raise } from '@vy/utils';
import { SideBarContext } from '../index.tsx';

export const useSidebarContext = () => {
  const context = useContext(SideBarContext);

  if (isNullOrUndefined(context)) {
    raise('useSidebarContext must be used inside SidebarProvider');
  }
  return context;
};
